import { writable, derived } from "svelte/store";

export const classes = writable({});